import { MouseEventHandler } from 'react';
import { useBoolean } from 'react-easyrocket';

/** Состояние и функции для управления кастомным свойством фокуса
 * автокомплита - в компоненте мы переопределяем правила по которым
 * автокоплит входит в сфокусированное состояние.
 */
export function useFocusBlur({
  onInputWrapperClick,
  onInputFrameClick
}: {
  /** Функция onClick которая может быть передана в inputWrapperProps - т.к. обработчик
   * клика создается здесь, то и переданный обработчик снаружи также добавляется здесь
   */
  onInputWrapperClick: MouseEventHandler<HTMLDivElement> | undefined;
  /** Функция onClick которая может быть передана в inputFrameProps - т.к. обработчик
   * клика создается здесь, то и переданный обработчик снаружи также добавляется здесь
   */
  onInputFrameClick: MouseEventHandler<HTMLDivElement> | undefined;
}) {
  const [isFocused, focus, blur, toggle] = useBoolean(false);

  const handleInputWrapperClick: MouseEventHandler<HTMLDivElement> = (e) => {
    // Нажатие попало в инпут, который в момент клика уже будет
    // гарантированно в фокусе => ничего не делаем. Иначе закрываем меню
    const isFocused = document.activeElement === e.target;
    if (!isFocused) {
      blur();
    }
    onInputWrapperClick?.(e);
  };
  const handleArrowIconClick: MouseEventHandler<SVGSVGElement> = (e) => {
    e.stopPropagation();
    toggle();
  };
  const handleInputFrameClick: MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
    focus();
    onInputFrameClick?.(e);
  };

  return {
    isFocused,
    blur,
    focus,
    handleInputWrapperClick,
    handleArrowIconClick,
    handleInputFrameClick
  };
}
